__webpack_require__.p = "https://static-assets.monzo.com/tabs-monzo-me/9d2132ad02a8d3a1f17683d7ace44a8ba81ea904/_next/";